<template>
  <div id="app" class="user-session">
    <div class="user-session__background">
      <img class="user-session__queropago-logo" :src="require('assets/images/queropago-white.svg')" alt="Quero Pago">
    </div>

    <div class="user-session__content">
      <div class="content__nav">
        <img class="nav__queropago-logo" :src="require('assets/images/queropago-white.svg')" alt="Quero Pago">
        <div class="nav__content-right">
          <help-dropdown-menu
            class="nav__link"
            :inverted-in-medium-screen="true"
          />
          <z-link
            tag="router-link"
            to="/entrar"
            class="nav__link nav__link--inverted"
          >
            <z-icon :icon="['far', 'user-circle']" class="nav__link-icon" size="large" />
            Entrar
          </z-link>
        </div>
      </div>

      <div class="content__wrapper" :class="{ 'content__wrapper--responsive-card': responsiveCard }">
        <template v-if="institution && institution.logoUrl">
          <img :src="institution.logoUrl" :alt="institution.name" class="content__institution-logo">
          <z-divider class="content__divider" />
        </template>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HelpDropdownMenu from 'components/help-dropdown-menu';

export default {
  props: {
    responsiveCard: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    HelpDropdownMenu,
  },
  computed: {
    ...mapState(['institution']),
  },
};
</script>

<style lang="scss" scoped>
.user-session {
  align-items: stretch;
  background-color: var(--color-white);
  display: flex;
  justify-content: flex-start;
  min-height: 100vh;

  @media screen and (max-width: $screen-md-max) {
    background-image: url('assets/images/login-bg-desktop.svg');
    background-size: cover;
  }
}

.user-session__background {
  background-image: url('assets/images/login-bg-desktop.svg');
  background-size: cover;
  width: calc(1140px * 0.25 + (100% - 1140px) / 2);

  @media screen and (max-width: $screen-md-max) {
    display: none;
  }
}

.user-session__queropago-logo {
  display: block;
  margin-left: auto;
  margin-right: calc(1140px * 0.25  - 202px);
  padding-top: var(--space-large);
  width: 202px;

  @media screen and (max-width: $screen-md-max) {
    display: none;
  }
}

.user-session__content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 75%;
  width: calc(1140px * 0.75);

  @media screen and (max-width: $screen-md-max) {
    align-items: center;
    padding: 0 var(--space-medium) var(--space-medium);
    width: 100%;
  }
}

.content__wrapper {
  display: inline-block;
  width: 100%;

  @media screen and (min-width: $screen-lg-min) {
    padding: var(--space-extra-large);
    width: calc(280px + var(--space-extra-large) * 2);
  }

  @media screen and (max-width: $screen-md-max) {
    margin: auto 0;
  }
}

.content__wrapper--responsive-card {
  @media screen and (max-width: $screen-md-max) {
    background-color: var(--color-background-minor);
    border-radius: var(--size-border-radius-large);
    box-shadow: var(--card-low-elevation);
    padding: var(--space-extra-large);
  }

  @media screen and (max-width: $screen-xs-max) {
    padding: var(--space-large);
  }
}

.content__nav {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: var(--space-large) var(--space-medium);
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    justify-content: space-between;
    padding: var(--space-large) 0;
  }
}

.content__nav--admission {
  justify-content: space-between;
}

.nav__queropago-logo {
  display: none;

  @media screen and (max-width: $screen-md-max) {
    display: block;
    width: 115px;
  }
}

.nav__link {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.nav__content-right {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.nav__link-icon {
  margin-right: var(--space-small);
}

.content__institution-logo {
  display: block;
  margin: 0 auto;
  width: 127px;
}

.content__divider {
  margin: var(--space-large) 0;
}

.nav__link--inverted {
  @media screen and (max-width: $screen-md-max) {
    color: var(--color-font-inverted);
  }
}
</style>
